"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDailyPerformanceValue = void 0;
const PerformanceValue_1 = require("./PerformanceValue");
const createDailyPerformanceValue = (object = {
    date: '',
    actualValue: PerformanceValue_1.createPerformanceValue(),
}) => object;
exports.createDailyPerformanceValue = createDailyPerformanceValue;
